import React from "react";
import { metaFor } from "@/lib/deviceMeta";

export default function TypeFilter({ types, active, onToggle, onAll }) {
  if (!types || types.length <= 1) return null;
  const allActive = active.size === 0 || active.size === types.length;
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="type-filter">
      <button
        data-testid="type-filter-all"
        onClick={onAll}
        className={`rounded-full px-2.5 py-1 text-[11px] font-semibold transition-colors ${
          allActive
            ? "bg-[#0055FF] text-white"
            : "bg-black/[0.05] text-[#52525B] hover:bg-black/10"
        }`}
      >
        הכל
      </button>
      {types.map((t) => {
        const meta = metaFor(t);
        const Icon = meta.icon;
        const on = !allActive && active.has(t);
        return (
          <button
            key={t}
            data-testid={`type-filter-${t}`}
            onClick={() => onToggle(t)}
            className="flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold transition-colors"
            style={{
              backgroundColor: on ? meta.color : meta.color + "18",
              color: on ? "#fff" : meta.color,
            }}
          >
            <Icon size={12} strokeWidth={2.4} />
            {meta.label}
          </button>
        );
      })}
    </div>
  );
}
